import type { HorrorRaceState } from "../types/game-state";
import { validateForfeitTurn } from "../validators/forfeit-turn.validator";

/**
 * Returns true when a FORFEIT_TURN action is currently legal for the given
 * player. Single source of truth: delegates to validateForfeitTurn so the
 * UI and the validator are always in sync.
 */
export function canForfeitTurn(
  state: HorrorRaceState,
  playerId: string,
): boolean {
  return validateForfeitTurn(state, { type: "FORFEIT_TURN", playerId }).valid;
}
